export const GCS_ABOUT_PATH = "about-us";
export const GCS_ASSETS_PATH = "assets";

export const GCS_PITCH_PATH =  GCS_ASSETS_PATH + "/pitch";
export const GCS_PARTNERS_PATH =  GCS_ASSETS_PATH + "/partners";